const EventEmitter = require('events');
class WxEventEmitter extends EventEmitter {
}
export const wxEventEmitter = new WxEventEmitter();
